try {
  if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');else require('./index.css');
} catch (e) {
  if (e.code !== 'MODULE_NOT_FOUND') {
    throw e; // Re-throw unexpected errors
  }

  console.warn('index.css / index-new.css not found, proceeding without it.');
}
import { jsxs, jsx } from 'react/jsx-runtime';
import { ErrorMessage } from '@design-system/error-message';
var CheckboxList = function CheckboxList(_ref) {
  var children = _ref.children,
    errorMessage = _ref.errorMessage;
  return jsxs("div", Object.assign({
    className: "cds-checkbox-list"
  }, {
    children: [children, errorMessage ? jsx(ErrorMessage, {
      message: errorMessage
    }) : null]
  }));
};
export { CheckboxList };